

































import Vue from 'vue';
import Component from 'vue-class-component';
import { calculateRequirementLevel, Requirement, RequirementMap } from '@/features/sr-model/Requirement';
import { Prop } from 'vue-property-decorator';
import { restClient } from '@/store/rest-client';

@Component
export default class RequirementItem extends Vue {

  private static DEFAULT_PARAGRAPH_MARGIN = 2;

  @Prop() regulationId: string;
  @Prop() requirement: Requirement;
  @Prop() requirementsById: RequirementMap;
  @Prop({ required: false, default: '' }) referencingStandard: string;
  @Prop({ required: false }) filterText: string;

  diffDialog = false;
  diff = '';

  get defaultParagraphMargin(): string {
    return RequirementItem.DEFAULT_PARAGRAPH_MARGIN + 'rem';
  }

  get calculatedParagraphMargin(): string {
    const marginLevel = calculateRequirementLevel(this.requirement, this.requirementsById);
    return (marginLevel * RequirementItem.DEFAULT_PARAGRAPH_MARGIN).toFixed(1) + 'rem';
  }

  get requirementText(): string {
    let requirementText = this.requirement.text;
    const filterText = this.filterText;
    if (filterText && filterText.trim().length >= 3) {
      const reg = new RegExp('(' + filterText + ')', 'gi');
      requirementText = requirementText.replaceAll(reg, '<span style="background: #fbd99d">$1</span>');
    }
    return requirementText;
  }

  compare() {
    restClient.get(
        `${ process.env.VUE_APP_REGULATIONS_BASE_URL }/sr-api/regulations/${ this.regulationId }/${ this.requirement.id }/amendment-diff`,
        { headers: { 'Content-Type': 'text/html' } }
    ).then(response => {
      this.diff = response.data;
      this.diffDialog = true;
    });
  }
}
